/*
     Title: reject-type API
     Description: reject-type API
     Author: Iqbal Hossain
     Date: 10-January-2022
     Modified: 10-January-2022
*/

export const REJECT_TYPE_API = {
  root: '/api/reject-type',
  fetch_all: 'api/reject-type/fetch-all',
  fetch_by_query: `/api/reject-type/fetch-by-query`,
  fetch_by_id: `/api/reject-type/fetch-by-id`,
  add: `/api/reject-type/add`,
  update: `/api/reject-type/update`,
  delete: `/api/reject-type/delete`,
  delete_by_range: `/api/reject-type/delete-range`
};

/** Change Log
 * 08-Jan-2022(Iqbal): Create (root, fetch_by_query, fetch_by_id, add, update, delete, delete_by_range )
 */
